<template>
  <div class="category-tab pxstrict border-bottom-1px" v-show="data.length > 0">
    <van-tabs
      :swipeable="true"
      :sticky="sticky"
      @change="onTab"
      v-model="tabActive"
    >
      <van-tab :key="item.categoryId" v-for="item in data" :title="item.categoryName">
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Tab, Tabs } from "vant";
export default {
  name: "category-tab",
  props: ["data"],
  data() {
    return {
      sticky: true,
      tabActive: "",
    };
  },
  components: {
    "van-tab": Tab,
    "van-tabs": Tabs,
  },
  // watch: {
  //   data: {
  //     deep: true,
  //     immediate: true,
  //     handler: function (val) {
  //       console.log(val, 'val')
  //     }
  //   }
  // },
  methods: {
    onTab(i) {
      this.$emit("onChange", i);
    },
  },
};
</script>

<style lang="less" scoped>
.category-tab.pxstrict{
  position: fixed !important;
  top: 88px;
  right: 0;
  left: 0;
  z-index: 99;
  /deep/ .van-tabs--line .van-tab__text--ellipsis {
    height: 44px;
  }

  /deep/ .van-tab--active {
    color: #405FFF;
  }
  /deep/ .van-tabs__line {
    background-color: #405FFF;
    width: 48px !important;
    bottom: 15px !important;
    top: auto !important;
  }
  /deep/ .van-tabs__nav--line{
  	padding-bottom: 15px;
  }
  /deep/ .van-tabs--line .van-tabs__wrap{
  	height: 44px;
  }
  /deep/ .van-hairline--top-bottom::after {
    border: 0;
  }

  /deep/ .van-tab {
    line-height: 44px !important;
    flex-basis: 28% !important;
    padding: 0 !important;
  }
}
/deep/ .category-tab::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 1px;
  content: "";
  width: 100%;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  background-color: #eee;
}
</style>
